module.exports = __webpack_public_path__ + "static/media/Sort-Z-A-White.9c312948.svg";